import { __decorate, __metadata } from "tslib";
import { Component } from 'decorators';
import template from './MoveApplicationToTenantView_New.html';
import './MoveApplicationToTenantNew.scss';
let MoveApplicationToTenantComponentNew = class MoveApplicationToTenantComponentNew {
    constructor() {
    }
};
MoveApplicationToTenantComponentNew = __decorate([
    Component({
        template,
    }),
    __metadata("design:paramtypes", [])
], MoveApplicationToTenantComponentNew);
export { MoveApplicationToTenantComponentNew };
